<template>
  <section class="content">
    <admin-header
      :title="'Exchange rates'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
      :disableQuickSearch="true"    
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  import AdminHeader from '../AdminHeader'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminExchangeRate',
    data () {
      return {
        newEntityScreen: 'Admin - Exchange Rates',
        searchEntityScreen: 'Admin - Exchange Rate search',
        filterEventName: 'admin-exchange-rate-filter',
        filterName: 'ExchangeRateFilter',
        entityName: 'exchange-rate'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/ExchangeRate/AdminExchangeRate.vue